import React, { useEffect, useState } from "react";
import {
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
  TextInput,
  Pressable,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import CloseIcon from "@assets/svg/CloseIcon";
import Text from "@components/CustomText";
import RadioButton from "@components/RadioButton";
import colors from "@constants/color";
import { normalize } from "@utils/metrics_1";
import { useNavigation } from "@react-navigation/native";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { SELF_DEACTIVATION } from "@constants/analyticsEventsCT";
import { checkReactivationReason, setReactivationReason } from "@services/api";
import { useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";

const PATH = "screens/SelfDeactivation/OpenAccount";

const OpenAccount = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const [selected, setSelected] = useState(0);
  const [text, setText] = useState("");

  const toggleFilters = () => {
    setVisible(false);
    setSelected(0);
  };
  useEffect(() => {
    checkReactivationReason().then(({ data }) =>
      dispatch(authActions.updateContact({ data: data.data_entered })),
    );
  }, [dispatch]);
  const handleEnableDisable = () => {
    if ((selected >= 1 && selected <= 6) || text.trim().length >= 10) {
      return false;
    }
    return true;
  };

  const handleReactivation = async (reason) => {
    try {
      const response = await setReactivationReason({
        reactivation_reason: reason,
      });
      dispatch(
        authActions.updateContact({
          data: true,
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };

  const reactivateAccount = () => {
    analytics.trackEvent(SELF_DEACTIVATION.REACTIVATE_REQUEST, {
      "request context": text,
    });
    handleReactivation(text);
    setVisible(false);
    setText("");
    setSelected(0);
  };

  return (
    <>
      <Modal
        transparent
        visible={visible}
        onRequestClose={toggleFilters}
        animationType="fade"
        statusBarTranslucent
        navigationBarTranslucent
      >
        <KeyboardAvoidingView
          style={styles.flex}
          behavior={Platform.OS === "ios" ? "padding" : "height"}
        >
          <View
            style={{
              flex: 1,
              ...StyleSheet.absoluteFill,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <View
              style={[styles.modalContainer, { paddingBottom: insets.bottom }]}
            >
              <View style={styles.modalHeader}>
                <Text style={styles.headText}>
                  {t(`${PATH}/reasonForReopen`)}
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    toggleFilters();
                    setSelected(0);
                  }}
                  style={{ marginTop: normalize(10) }}
                >
                  <CloseIcon fillOpacity={0.86} width={24} height={24} />
                </TouchableOpacity>
              </View>
              <View style={{ marginTop: 5 }}>
                <View>
                  <>
                    <TextInput
                      placeholder={t(`${PATH}/placeHolder`)}
                      multiline={true}
                      numberOfLines={2}
                      onChangeText={(newText) => setText(newText)}
                      style={styles.textInput}
                      maxLength={100}
                    />
                    <View style={styles.count}>
                      <Text style={styles.countText}>
                        {text.trim().length <= 100 ? text.trim().length : ""}
                        /100
                      </Text>
                    </View>
                  </>

                  <View style={styles.buttonView}>
                    <Pressable
                      disabled={handleEnableDisable()}
                      style={[
                        styles.button,
                        {
                          backgroundColor: handleEnableDisable()
                            ? "rgba(0, 0, 0, 0.1)"
                            : "#E40046",
                        },
                      ]}
                      onPress={() => {
                        reactivateAccount();
                      }}
                    >
                      <Text style={styles.buttonText}>
                        {t(`${PATH}/submit`)}
                      </Text>
                    </Pressable>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </KeyboardAvoidingView>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  filterContainer: {
    justifyContent: "space-between",
    borderWidth: 1,
    borderColor: "transparent",
    borderBottomColor: "#ddd",
    padding: 10,
  },
  secondaryText: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  modalContainer: {
    backgroundColor: "#fff",
    position: "absolute",
    bottom: 0,
    width: "100%",
    paddingVertical: normalize(20),
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  modalHeader: {
    justifyContent: "space-between",
    flexDirection: "row",
    marginHorizontal: normalize(16),
  },
  textInput: {
    marginHorizontal: normalize(16),
    borderBottomWidth: 1,
    fontSize: normalize(14),
    lineHeight: normalize(20),
    borderBottomWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.3)",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  count: {
    marginEnd: normalize(16),
    marginTop: normalize(6),
    alignItems: "flex-end",
  },
  headText: {
    flex: 1,
    lineHeight: normalize(30),
    fontSize: normalize(20),
    fontFamily: "NotoSansDevanagari-Bold",
  },
  countText: {
    fontSize: normalize(12),
    lineHeight: normalize(18),
    color: "rgba(0, 0, 0, 0.56)",
  },
  wrapperStyle: {
    borderBottomWidth: 1,
    borderBottomColor: "#F4F4F4",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },

  buttonView: {
    paddingHorizontal: normalize(16),
    backgroundColor: "white",
  },
  button: {
    marginTop: normalize(16),
    borderRadius: 6,
    paddingVertical: normalize(12),
  },
  buttonText: {
    fontSize: normalize(18),
    lineHeight: normalize(28),
    color: "white",
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  others: {
    marginTop: 16,
    borderTopWidth: 1,
    borderColor: "#F4F4F4",
  },
});

export default OpenAccount;
